export default {
  OPTION_HEIGHT: 48,
  OPTIONS_DIVIDER_HEIGHT: 4,
  DEFAULT_VISIBLE_ITEM_COUNT: 5,
  DROPDOWN_MIN_WIDTH: 100,
  DROPDOWN_MAX_WIDTH: 400,
};
